import type { AxiosError, AxiosResponse } from "axios";

export const handleRequestError = (
  exception: unknown
): AxiosResponse | null => {
  const axiosError = exception as AxiosError | undefined;
  return axiosError?.response ?? null;
};

export const normalizeError = (error: unknown): Error => {
  if (error instanceof Error) {
    return error;
  }

  if (typeof error === "string") {
    return new Error(error);
  }

  try {
    return new Error(JSON.stringify(error));
  } catch {
    return new Error("Erro desconhecido");
  }
};